<template>
  <div>
    <div class="toplist">
      <p>充值金额</p>
      <div class="listall">
        <div class="listitem" v-for="(item, index) in list" :key="index" :class="{ active: index === code }"
          @click="getindex(item, index)">
          <div class="remark" v-if="item.remark">
            <span>{{ item.remark }}</span>
          </div>
          <p>¥{{ item.investMoney / 100 }}</p>
          <dl v-if="item.giftContext">{{ item.giftContext }}</dl>
        </div>
      </div>
      <dl>{{ tips }}</dl>
    </div>
    <p style="margin: 0.2rem 0.35rem; font-size: 0.32rem; text-align: left">
      支付方式
    </p>
    <md-field class="radio-field" style="padding: 0">
      <div v-for="(item, index) in banks" :key="index">
        <div class="paylinshe" v-if="item.code != 'wx'" @click="paywap(item, index)">
          <div class="listebnr">
            <img :src="item.img" alt="" />
            <span>{{ item.name }}</span>
          </div>
          <div class="lischeckj">
            <div class="serbrtn" v-if="item.isService">
              <span>{{ item.serviceFee }}%手续费</span>
            </div>
            <div class="link" v-if="item.code === 'taobao'">
              <a v-if="item.pcShopCodeUrl" @click.stop="jumpUrl(item.pcShopCodeUrl)">前往淘宝店铺</a>
            </div>
            <md-icon v-if="index === paycode" name="success" color="orangeRed" size="lg"></md-icon>
            <md-icon v-if="index != paycode" name="check" size="lg"></md-icon>
          </div>
          <p v-if="item.waring" class="waring">{{ item.waring }}</p>
        </div>
      </div>
    </md-field>

    <md-button type="warning" @click="pay" style="margin-top: 0.5rem">
      <md-activity-indicator v-if="loading" class="md-activity-indicator-css" type="carousel" :size="15" color="#fff"
        text-color="#fff"></md-activity-indicator>
      <span v-else>確認支付</span>
    </md-button>
    <div v-html="payGateWay" style="width: 100%; height: 1rem">
      {{ payGateWay }}
    </div>

    <!-- 淘宝订单号输入框 -->
    <md-dialog :closable="false" v-model="asyncDialog.open" :btns="asyncDialog.btns">
      <md-input-item type="text" preview-type="text" v-model="asyncDialog.code" title="淘宝订单号" placeholder="请输入淘宝订单号"
        is-title-latent></md-input-item>
    </md-dialog>
  </div>
</template>
<script>
import {
  Amount,
  Field,
  RadioList,
  Button,
  Dialog,
  Toast,
  ActivityIndicator,
  InputItem
} from "mand-mobile";
import { isBlank } from "@/until/common.js";

export default {
  name: "List",
  components: {
    [Amount.name]: Amount,
    [Field.name]: Field,
    [Button.name]: Button,
    [ActivityIndicator.name]: ActivityIndicator,
    [Dialog.name]: Dialog,
    [RadioList.name]: RadioList,
    [InputItem.name]: InputItem
  },
  data() {
    return {
      list: [],
      tips: "",
      code: null, // 当前选中充值金额套餐
      payGateWay: "",
      banks: [], // 支付方式list
      paycode: null, // 当前选中支付方式索引
      way: {}, // 当前选中支付方式
      loading: false,
      itemAre: {},
      asyncDialog: {
        open: false,
        btns: [
          {
            text: "确定",
            handler: this.onBasicConfirm
          }
        ],
        code: ""
      }
    };
  },
  activated() {
    this.getcreduit();
    this.payList();
  },
  methods: {
    getindex(item, index) {
      this.code = index;
      this.itemAre = item;
    },
    // 选择支付方式
    paywap(item, index) {
      this.paycode = index;
      this.way = item;
    },
    payList() {
      this.ajax.AJAx(this.ports.paywayshop, "post", {}).then(res => {
        this.banks = res;
      });
    },
    pay() {
      const { code, paycode } = this;
      if (code === null) {
        Toast.failed("請选择充值套餐");
        return;
      }
      if (paycode === null) {
        Toast.failed("请选择充值方式");
        return;
      }

      let par = {
        clientBackUrl: window.location.origin + "/#/chongzhi",
        depositId: this.itemAre.id,
        wayId: this.way.id
      };

      if (this.way.code === "taobao") {
        // 淘宝需输入淘宝单号
        this.asyncDialog.code = "";
        this.asyncDialog.open = true;
        return false;
      }

      this.loading = true;
      this.ajax
        .AJAx(this.ports.payshopsubmit, "post", par)
        .then(res => {
          if (this.way.code === "paypal") {
            var url =
              res.clientUrl +
              "?client_id=" +
              res.paySign +
              "&custom_id=" +
              res.detail.outTradeNo +
              "&amount=" +
              res.detail.totalPrice +
              "&type=1";
            window.location.href = url;
          } else {
            this.payGateWay = res.paySign;
            var that = this;
            setTimeout(function () {
              that.loading = false;
              document.forms[0].submit();
            }, 10);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 淘宝支付 输入订单号回调
    onBasicConfirm() {
      if (isBlank(this.asyncDialog.code)) {
        Toast.failed("淘宝订单号不能为空");
        return false;
      }
      var myregs = /^[0-9]*$/;
      if (!myregs.test(this.asyncDialog.code)) {
        Toast.failed("输入有误，淘宝订单号为纯数字的编号");
        return
      }
      this.asyncDialog.open = false;

      let par = {
        clientBackUrl: window.location.origin + "/#/chongzhi",
        depositId: this.itemAre.id,
        wayId: this.way.id,
        taoBaoCode: this.asyncDialog.code
      };
      this.loading = true;
      this.ajax
        .AJAx(this.ports.payshopsubmit, "post", par)
        .then(res => {
          this.loading = false;
          Toast.succeed('提交成功,请等待后台审核')
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getcreduit() {
      this.ajaxconfig
        .AJAxConfig(this.ports.shopDepositlist, "post", {})
        .then(res => {
          this.list = res;
        });
      this.ajaxconfig
        .AJAxConfig(this.ports.getPayWarnInfo, "post", {})
        .then(res => {
          this.tips = res;
        });
    },
    // 跳转外链
    jumpUrl(url) {
      if (url) {
        window.open(url);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.toplist {
  background-color: white;

  p {
    margin-left: 5%;
    width: 90%;
    padding-top: 0.5rem;
    text-align: left;
    font-size: 0.3rem;
  }

  dl {
    width: 90%;
    margin-left: 5%;
    font-size: 0.2rem;
    line-height: 0.4rem;
    text-align: left;
    white-space: pre-line;
    padding-bottom: 0.2rem;
  }

  .listall {
    width: 90%;
    margin-left: 5%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 0.2rem;

    .listitem {
      margin-bottom: 0.2rem;
      background-color: rgba(249, 249, 249, 100);
      border: 2px solid rgba(238, 238, 238, 100);
      width: 30%;
      height: 1.5rem;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .remark {
        position: absolute;
        right: 0;
        top: 0;
        background-color: #ff3a30;
        font-size: 0.18rem;
        color: white;
        padding: 0.05rem 0.12rem;
      }

      p {
        font-size: 0.4rem;
        font-weight: bolder;
        color: #ff3a30;
        text-align: center;
      }

      dl {
        color: #9f9f9f;
        font-size: 0.2rem;
        text-align: center;
      }
    }

    .active {
      background-color: rgba(252, 244, 233, 100);
      border: 2px solid rgba(250, 171, 28, 100);
    }
  }

  .listall:after {
    // 使用伪类元素占据单位，不影响页面
    content: "";
    height: 0;
    width: 30%;
  }
}

.paylinshe {
  width: 94%;
  margin-left: 3%;
  height: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(248, 248, 248, 100);
  position: relative;
}

.waring {
  position: absolute;
  bottom: 0.01rem;
  font-size: 0.12rem;
}

.listebnr {
  display: flex;
  height: 100%;
  align-items: center;
  font-size: 0.28rem;

  img {
    width: 0.5rem;
    height: auto;
    margin-right: 0.2rem;
  }
}

.lischeckj {
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;

  .serbrtn {
    width: 1.5rem;
    height: 0.3rem;
    color: rgba(246, 57, 13, 100);
    font-size: 0.16rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    border: 1px solid rgba(246, 57, 13, 100);
  }

  .link {
    color: #1890ff;
    font-size: 0.12rem;
    margin-right: 1.2rem;
  }
}
</style>
